import React from "react";
import classes from "./HeroSection.module.scss";
import Kunai from "../../../UI/Icons/Kunai";
import { isFrappeOrJotFormClass } from "../../../../utils/helpers";
import { Breadcrumb } from "react-bootstrap";

const HeroSection = ({ scholarshipCountryData }: any) => {
  const heroSectionData = scholarshipCountryData?.heroSection ?? {};

  return (
    <div id="countrySholarshipsBanner" className={classes.countrySholarshipsPage}>
      <div className={classes["breadcrum-container"]}>
        <Breadcrumb>
          <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/student-services/study-abroad-scholarships">Scholarships</Breadcrumb.Item>
          {scholarshipCountryData?.scholarships_country?.countryName && (
            <Breadcrumb.Item href="">{scholarshipCountryData?.scholarships_country?.countryName ?? ""}</Breadcrumb.Item>
          )}
        </Breadcrumb>
      </div>

      <h1 className={classes.heading}>{heroSectionData?.title ?? ""}</h1>
      <div className={classes.description} dangerouslySetInnerHTML={{ __html: heroSectionData?.description ?? "" }}></div>
      <button
        className={`${classes.ctaBtn} ${heroSectionData?.ctaBtn?.btnLink ? "" : isFrappeOrJotFormClass(heroSectionData?.ctaBtn?.formId ?? "")}`}
        onClick={() => {
          heroSectionData?.ctaBtn?.btnLink && window.open(heroSectionData?.ctaBtn?.btnLink, "_blank");
        }}
      >
        {heroSectionData?.ctaBtn?.btnTitle ?? ""}
      </button>
      <div className={classes["kunai1"]}>
        <Kunai width={20} height={20} />
      </div>
      <div className={classes["kunai2"]}>
        <Kunai width={20} height={20} />
      </div>
      <div className={classes["kunai3"]}>
        <Kunai width={20} height={20} color="#ffffff80" />
      </div>
      <div className={classes["dot1"]}></div>
      <div className={classes["dot2"]}></div>
      <div className={classes["empty-circle"]}></div>
    </div>
  );
};

export default HeroSection;
